export default __webpack_public_path__ + "static/section2-plumbing-9a2d327b828702821494494c9c017624.webp";